<template>
  <div id="main-wrapper">
    <NavbarDark />

    <!-- Page Title -->
    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">Our Services</h2>
            <span class="ipn-subtitle">Professional Trade Services for Your Property</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Services Section -->
    <section class="gray-simple">
      <div class="container">
        <div class="row justify-content-center mb-5">
          <div class="col-lg-8 text-center">
            <h3 class="fw-bold">Trusted Trades, On Demand</h3>
            <p class="text-muted mt-2">
              We connect you with licensed, vetted professionals for all your property maintenance
              and improvement needs. Click on a service below to submit a request and we'll get
              back to you promptly.
            </p>
          </div>
        </div>

        <div class="row">
          <!-- Electrical -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img electrical d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-bolt"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Electrical</h5>
                <p class="card-text text-muted">
                  From panel upgrades and outlet installations to wiring inspections and lighting
                  fixtures, our licensed electricians handle all residential
                  electrical work safely and up to code.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Electrical')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Plumbing -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img plumbing d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-faucet-drip"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Plumbing</h5>
                <p class="card-text text-muted">
                  Leaky pipes, drain clogs, water heater installations, fixture replacements, and
                  more. Our certified plumbers respond quickly to keep your water systems running
                  smoothly without disruption.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Plumbing')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Lawn Care -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img lawn d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-seedling"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Lawn Care</h5>
                <p class="card-text text-muted">
                  Lawn mowing, grass trimming, edge & fence lines, basic yard cleaning, and light
                  debris removal such as leaves and grass clippings — keeping your property's
                  exterior neat and tidy.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Lawn Care')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Handyman -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img handyman d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-screwdriver-wrench"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Handyman</h5>
                <p class="card-text text-muted">
                  Drywall repairs, painting, door and window fixes, shelf installations, and all
                  the small-to-medium jobs around the property. One call covers a wide range of
                  general maintenance tasks.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Handyman')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- HVAC -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img hvac d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-wind"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">HVAC</h5>
                <p class="card-text text-muted">
                  Heating, ventilation, and air conditioning — installation, maintenance, and
                  emergency repairs. Our HVAC technicians ensure your property stays comfortable
                  and energy-efficient in every season.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('HVAC')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Cleaning -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img cleaning d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-soap"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Cleaning</h5>
                <p class="card-text text-muted">
                  Deep cleans, move-in/move-out cleaning, and recurring maintenance cleans for
                  residential properties. Leave the scrubbing to us.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Cleaning')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Painting -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img painting d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-paint-roller"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Painting</h5>
                <p class="card-text text-muted">
                  Interior and exterior painting with quality finishes. From single rooms to full
                  property repaints, our painters deliver clean, long-lasting results on time.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Painting')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Mini Split Cleaning -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img minisplit d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-snowflake"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Mini Split Cleaning</h5>
                <p class="card-text text-muted">
                  Professional cleaning of ductless mini split units — filters, coils, and drainage
                  — to maximize efficiency, air quality, and equipment lifespan.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Mini Split Cleaning')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Duct Cleaning -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img duct d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-filter"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Duct Cleaning</h5>
                <p class="card-text text-muted">
                  Thorough cleaning of your HVAC ductwork to remove dust, allergens, and debris.
                  Improve indoor air quality and reduce energy costs with regular duct maintenance.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Duct Cleaning')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Roofing -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img roofing d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-house-chimney"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Roofing</h5>
                <p class="card-text text-muted">
                  Roof repairs, storm damage repair, leak detection and repairs, and full roof
                  inspections. We assess and fix issues promptly to protect your property from
                  the elements.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Roofing')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>

          <!-- Driveway Seal -->
          <div class="col-12 col-sm-6 col-lg-4 mb-4">
            <div class="trade-card card h-100 border-0 shadow-sm">
              <div class="trade-card-img driveway d-flex align-items-center justify-content-center">
                <i class="fa-solid fa-road"></i>
              </div>
              <div class="card-body">
                <h5 class="card-title fw-bold">Driveway Seal</h5>
                <p class="card-text text-muted">
                  Crack sealing, resurfacing, and professional sealcoating to protect your driveway
                  from weathering and extend its lifespan — keeping your property looking its best.
                </p>
              </div>
              <div class="card-footer bg-transparent border-0 pb-3">
                <button @click="requestService('Driveway Seal')" class="btn btn-primary w-100">
                  <i class="fa-solid fa-arrow-right me-2"></i>Request Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import NavbarDark from "@/components/navbar/navbar-dark.vue";
import FooterDark from "@/components/footer/footer-dark.vue";
import ScrollToTop from "@/components/scroll-to-top.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const requestService = (service) => {
  router.push({ path: "/trade-request", query: { service } });
};
</script>

<style scoped>
.trade-card {
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.trade-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12) !important;
}

.trade-card-img {
  height: 170px;
  font-size: 4.5rem;
  color: #fff;
  border-radius: 12px 12px 0 0;
}

.electrical {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.plumbing {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.lawn {
  background: linear-gradient(135deg, #22c55e, #15803d);
}

.handyman {
  background: linear-gradient(135deg, #f97316, #c2410c);
}

.hvac {
  background: linear-gradient(135deg, #06b6d4, #0e7490);
}

.cleaning  { background: linear-gradient(135deg, #a78bfa, #7c3aed); }
.painting  { background: linear-gradient(135deg, #f472b6, #be185d); }
.minisplit { background: linear-gradient(135deg, #67e8f9, #0284c7); }
.duct      { background: linear-gradient(135deg, #94a3b8, #475569); }
.driveway  { background: linear-gradient(135deg, #78716c, #44403c); }
.roofing   { background: linear-gradient(135deg, #ef4444, #991b1b); }
</style>
